import { formatMoney } from "@smartrr/shared/utils/formatMoney";
import { DEFAULT_VARIANT_TITLE } from "@smartrr/shared/constants";
import PriceChangesMapperInterface from "./PriceChangesMapperInterface";
import { PriceChangeInterface } from "../domain/PriceChangeInterface";

export default class PriceChangesMapper implements PriceChangesMapperInterface {
  public map(data: any[]): PriceChangeInterface[] {
    const priceChanges = data.map(
      item =>
        ({
          uuid: item.id,
          purchasableName: item.purchasableName,
          purchasableVariantName:
            item.purchasableVariantName === DEFAULT_VARIANT_TITLE ? null : item.purchasableVariantName,
          oldPrice: formatMoney(item.oldPrice, item.currency),
          newPrice: formatMoney(item.newPrice, item.currency),
          affectedSubscriptionsCount: item.affectedSubscriptionsCount,
          detectedAt: new Date(item.detectedAt).toLocaleDateString(navigator.language, {
            year: "numeric",
            month: "short",
            day: "numeric",
          }),
          status: item.status,
        }) as PriceChangeInterface
    );

    return priceChanges;
  }
}
